<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="parentData"
            ref="masterComponent"
            :actions="false"
  >
    <template slot="expandedRowRender" slot-scope="{text}">
      <template v-for="ve in master.valoresExpandidos">
        {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
      </template>
    </template>
  </g-master>
</template>
<script>
  export default {
    props: ['empleadoseleccionado', 'endpoint'],
    data () {
      return {
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'},
            {label: 'Creado por Hist', column: 'created_by_hist'},
            {label: 'Creado Hist', column: 'created_on_hist'},
            {label: 'Modificado por Hist', column: 'modified_by_hist'},
            {label: 'Modificado Hist', column: 'modified_on_hist'}
          ],
          endpoint: this.endpoint,
          tableSetup: {
            customSlots: ['expandedRowRender'],
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Id Atributo', dataIndex: 'id_att', sorter: true},
              {title: 'Descripcion Atributo', dataIndex: 'att_desc', sorter: true},
              {title: 'Valor Atributo', dataIndex: 'att_value', sorter: true}
            ]
          }
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/AttributoHistorico.vue